import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierSR.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'gateway.PremierSR.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'gateway.PremierSR.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'gateway.PremierSR.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierSR.wizard.error',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierSR.wizard.error.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierSR.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierSR.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
});
